<template>
    <div>
      <el-form
        :model="validateForm"
        ref="validateForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="商户名称"
          prop="name"
          :rules="[{ required: true, message: '商户名称不能为空' }]"
        >
          <el-input
            v-model.number="validateForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('validateForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('validateForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        validateForm: {
          name: ''
        }
      }
    },
    methods: {
      submitForm (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            console.log(this.validateForm.name)
            this.$http.post('/merchant/merchant/add',{name:this.validateForm.name}).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/api/index/index');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
          } else {
            return false
          }
        })
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
  </script>